import React from 'react';
import { connect } from 'react-redux';
import { Segment, Header, Icon, Grid, Breadcrumb, Message } from 'semantic-ui-react';
import { groupBy as _groupBy, keys as _keys, isEmpty as _isEmpty, keyBy as _keyBy } from 'lodash';

import './OpenRequestsContainer.less';

import ProjectsBids from '../../components/ProjectsBids/ProjectsBids'
import { setActiveMenuItem } from '../../store/actions/actions';
import { getServiceRequestBids } from '../../services/Project';
import { getSellerServices } from '../../services/Services';

class OpenRequestsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sellerServices: []
        }
    }

    async componentDidMount() {
        this.props.setActiveMenuItem('open-requests');
        const sellerServices = await getSellerServices().then((res) => {
            return res.data || []
        });
        this.setState({ sellerServices });
    }

    handlePinToggle = async (service, servicePinID) => {
        const { sellerServices } = this.state;
        _.each(sellerServices, ss => ss.serviceID === service.serviceID ? ss.servicePinID = servicePinID : '');
        this.setState({ sellerServices });
    }

    render() {
        const { sellerServices } = this.state;
        const visitTime = this.props.location.state && this.props.location.state.visitTime;

        return (
            <div className="LosingBidsContainer animated fadeInRight">
                <Segment.Group>
                    <Segment size="massive" className="no-radius">
                        <Header as="h1">
                            <Header.Content>
                                Active Jobs Needing Quotes
                            </Header.Content>
                        </Header>
                    </Segment>

                </Segment.Group>
                <Grid celled>
                    {/* <Grid.Row>
                        <Grid.Column>
                        <Message info>
                            <Message.Header>Note:</Message.Header>
                            <p>Buyers have the option to select any quote they wish based upon prices, reviews, distance, etc even if that quote is not the lowest price.</p>
                        </Message>
                        </Grid.Column>
                    </Grid.Row> */}

                    <Grid.Row>
                        <Grid.Column>

                            {sellerServices.map((service, i) => {
                                return (
                                    <ProjectsBids hideDetails={true} service={service} getRequests={getServiceRequestBids}
                                        onTogglePin={(servicePinID) => this.handlePinToggle(service, servicePinID)}
                                        key={`service${i}`} history={this.props.history}
                                        visitTime={visitTime}
                                    />
                                )
                            })}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = {
    setActiveMenuItem
}

export default connect(null, mapDispatchToProps)(OpenRequestsContainer);